import { Button, Dialog, DialogContent, TextField } from "@mui/material";
import { t } from "i18next";
import React, { useContext, useState } from "react";
import { client } from "../..";
import { createQBP } from "../../api/api";
import { isNullOrEmpty, showErrorMessage } from "../../helper/helper";
import { transactorId } from "../../helper/TokenHelper";
import { CompanyContext } from "./CompanyDetail";
import { Organisation } from "../../models/organisation/OrganisationModelV2";

type Props = {
    org: Organisation
}

export function ButtonCreateQualityPrices({ org }: Props) {

    const reload = useContext(CompanyContext)

    const [open, setOpen] = useState(false)
    const [name, setName] = useState(undefined)

    function creatNewQualityLevel() {
        client.mutate({
            mutation: createQBP,
            variables: {
                input: {
                    name: name,
                    organisation_id: org.id,
                    transactor_id: transactorId()
                }
            }
        }).then(() => {
            reload.reload()
        }).catch((e) => {
            showErrorMessage(e)
        }).finally(() => setOpen(false))
    }

    function onInputChange(value: string) {
        setName(value)
    }

    return <>
        <Button onClick={() => setOpen(true)} variant="contained">
            {t('create_plus')}
        </Button>
        <Dialog open={open} onClose={() => setOpen(false)}>
            <DialogContent>
                <div className="pempem-flex-col gap10">
                    <p>
                        {t('create_new_quality_level')}
                    </p>
                    <TextField
                        variant="standard"
                        value={name}
                        inputProps={{ style: { textAlign: 'center', fontSize: "26px", fontWeight: "700", marginLeft: "10px" } }}
                        onChange={(e) => onInputChange(e.target.value)}
                    />
                    <Button disabled={isNullOrEmpty(name)} variant="contained" onClick={creatNewQualityLevel}>
                        {t('confirm')}
                    </Button>
                </div>
            </DialogContent>
        </Dialog>

    </>
}